export class HttpError {
  // An AppSync authorizer denial arrives as a 401 network error, not as a
  // status on the response, so it otherwise falls through to a generic
  // "something went wrong" message.
  static isUnauthorized(err: any): boolean {
    const status = err?.networkError?.status ?? err?.status;
    if (status === 401 || status === 403) {
      return true;
    }
    return (err?.graphQLErrors ?? []).some(
      (i: any) =>
        i?.errorType === 'UnauthorizedException' ||
        i?.extensions?.code === 'UNAUTHENTICATED',
    );
  }
}
